
  import { defineComponent, PropType } from 'vue';

  import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeColumnConfig, TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { TBaseViewsCountTableItem, TStatisticsChartItem } from '../../types/statistics/common';
  import { TChartBaseConfig } from './charts/chartTypes';
  import StatisticsVerticalColumnChart from './charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from './StatisticsByTimeTabs.vue';

  export default defineComponent({
    name: 'StatisticsViewsCountByTimeTab',
    components: {
      TableTree,
      StatisticsByTimeTabs,
      StatisticsVerticalColumnChart,
    },
    props: {
      tableStorePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      chartStorePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      filter: {
        type: Object as PropType<TFilter>,
        required: true,
      },
      periodColumn: {
        type: Object as PropType<TTableTreeColumnConfig>,
        required: false,
        default: () => ({
          field: 'period',
          title: 'Период',
        }),
      },
    },
    data(): { tableConfig: Omit<TTableTreeConfig<TBaseViewsCountTableItem>, 'storePaths'> } {
      return {
        tableConfig: {
          columns: [
            this.periodColumn,
            {
              field: 'viewsCount',
              title: 'Количество просмотров',
              textAlign: 'right',
              width: 188,
            },
          ],
          pagination: {
            size: 12,
          },
        },
      };
    },
    computed: {
      getChartConfigs(): TChartBaseConfig<TStatisticsChartItem> {
        return {
          storePaths: this.chartStorePaths,
          labelKey: 'label',
          tooltip: {
            key: 'text',
          },
          columns: [
            {
              name: 'Количество просмотров',
              valueKey: 'value',
            },
          ],
        };
      },
    },
  });
